/* eslint-disable */
// @ts-nocheck
import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import DruidQuery from '../../core/DruidQuery';
import AppsStore from '../../../../main/stores/AppsStore_LEGACY';
import PureQueryBuilder from '../PureQueryBuilder';
import MultiEventSelect from '../PureQueryBuilder/MultiEventSelect';
import FraudSelect from './FraudSelect';
import {
  getEventForTimeseries,
  addStandardSourceQueryForEvents,
  getDefaultGranularityFromContext,
  updateDimensionsWithDate,
  generateAdditionalQueriesFromEvents,
  removeEventDescriptionsFromEvents,
  getNonDimensionColumnKeysFromSelectedColumns,
  deriveOrganic,
} from './utils';
import { getDruidFiltersByDimension, isDomainAnalyticsAvailable } from '../../../actions/DruidActions';
import {
  convertFiltersToNativeDruidFilters,
  convertMultipleQueriesToNativeDruidFilters,
  convertNativeFiltersToDisplayFormat,
  mergeFilters,
  getListOfDimensionsAndValues,
} from '../../../support/utils/druid/nativeQueries';
import { updateFilter } from '../../../support/utils/druid/updateQuery';
import { getServerSideTopicNamesForTrends, getColumnDataFieldKey } from '../../../support/utils/eo_helpers';

import store from '../../../../main/reducers';

import { setPageState } from '../../../actions/ShareableActions';
import { selectNamespaceOrderBy } from '../../../selectors/ShareableSelectors';
import { getAdPartners } from '../../../../main/actions/AdPartnerActions';
import { getState as selectAdPartner } from '../../../../main/selectors/AdPartnerSelectors';
import { getState as selectAccessControl } from '../../../../main/selectors/AccessControlSelectors';
import { DEFAULT_BLOCKED_EVENT_INDICATOR } from '../../../../main/screens/ScreenAdsFraud/fraudConstants';
import { SK_ADNETWORK_DATASOURCE } from '../../../../common/support/eo_mapping/datasources';
import { shouldLoadPartialData, getSampleEndDate } from '../../../../common/support/analytics/longRangePartialData';
import { getDruidState } from '../../../selectors/DruidSelectors';
import { selectDisableOrganicToggle } from './selectors';
import { ANALYTICS_CONTEXT } from '../../../../../../shared/constants/analytics';

class DruidQueryBuilder extends React.Component {
  static propTypes = {
    /**
     * maximum number of dimension fields allowed in query
     */
    maxDimensions: PropTypes.number,
    /**
     * minimum number of dimension fields allowed in query
     */
    minDimensions: PropTypes.number,
    /**
     * query start date
     */
    start_date: PropTypes.string,
    /**
     * query end date
     */
    end_date: PropTypes.string,
    /**
     * array of sources to query. Ex: ['eo_click', 'eo_install']
     * see common/support/eo_mapping/datasources.js for more sources
     */
    data_sources: PropTypes.arrayOf(PropTypes.string),
    /**
     * default filter for initial query
     */
    defaultFilter: PropTypes.object,
    /**
     * default dimensions for initial query
     */
    default_dimensions: PropTypes.array,
    /**
     * filters that are required and can't be changed.
     * will overwrite defaultFilter if there is overlap
     */
    requiredFilter: PropTypes.object,
    /**
     * required filters that we do not wish to expose to the user.
     * introduced with the new summary page in April 2020.
     * filter valued passed in will be merged with the user-created filter before the DruidQuery is requested
     * not passed in to PureQueryBuilder since we do not want the user to see this filter
     */
    implicitRequiredFilter: PropTypes.object,
    /**
     * filter that will override even the filters stored in
     * localstorage
     */
    overrideInitialFilter: PropTypes.object,
    /**
     * dimensions that will override dimensions stores in localstorage
     */
    overrideInitialDimensions: PropTypes.array,
    /**
     * source specific options for the query
     * example:
     *  {
     *    eo_install: {
     *      dimensions: [ 'hours_from_last_attributed_touch_to_event' ] }
     *    }
     * }
     */
    dataSourceSpecificQueryOptions: PropTypes.object,
    /**
     * use dataSourceSpecificQueryOptions as the DruidQuery sourceQuery if true.
     * used for the new summary page since we want the sourceQuery to be based on the selected product
     * instead of being read from shareable state
     */
    useDataSourceSpecificQueryOptionsAsSourceQuery: PropTypes.bool,
    /**
     * do not add custom events to the event dropdown if true
     */
    excludeCustomEvents: PropTypes.bool,
    testid: PropTypes.string,
    /**
     * context passed as a property of DruidQuery.query -- TODO MAKE REQUIRED
     */
    context: PropTypes.string,
    eo_cutoff_date: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object, // Date
    ]),
    /**
     * overrides for v1/druid.js logic. see DruidQuery.jsx for shape
     */
    overrides: PropTypes.object,
    /**
     * Initial state for whether we are requesting unique data or not. Note
     * 'unique' state is set from this prop but then maintained as state on this
     * component. Warning: DruidQuery.jsx will append aggregations and set metric
     */
    initialUnique: PropTypes.bool,
    /**
     * Though we always want to show the 'Unique' checkbox, we sometimes want
     * it disabled (like on Summary time series page) where user can't toggle
     */
    disableUniqueToggle: PropTypes.bool,
    /**
     * Initial state for whether we are requesting organic data or not. Note
     * 'organic' state is set from this prop but then maintained as state on this
     * component. Warning: DruidQuery.jsx will append aggregations and set metric
     */
    initialOrganic: PropTypes.bool,
    /**
     * Though we always want to show the 'Organic' checkbox, we sometimes want
     * it disabled (like on Summary time series page) where user can't toggle
     */
    disableOrganicToggle: PropTypes.bool,
    /**
     * If this DruidQueryBuilder will have an export button (which will still
     * need to be passed in as a child), we need to pass bool in as prop because
     * the 'Unique' checkbox will need to be moved over to make room
     */
    hasExportButton: PropTypes.bool,
    /**
     * If this DruidQueryBuilder will have a unique count toggle.
     */
    hasUniqueToggle: PropTypes.bool,
    /**
     * If this DruidQueryBuilder will have a organic count toggle.
     */
    hasOrganicToggle: PropTypes.bool,
    /**
     * If this DruidQueryBuilder will have a Split SKAN data toggle.
     */
    hasSplitSkanDataToggle: PropTypes.bool,
    /**
     * List of event names to choose from for timeseries charts.
     * If empty, event name dropdown will not appear
     */
    eventList: PropTypes.array,
    /**
     * (optional) Overrides the default druid filters list
     */
    filterTypesList: PropTypes.array,
    /**
     * Refer to DLA-2398
     *
     * (optional) Overrides the default druid filter options on filter rows (not compare by row).
     * Note, this prop is necessary because there are cases when the filter options in the compare by row need to different from the filter options on the filter rows.
     */
    filterTypesListFilterRow: PropTypes.array,
    /**
     * shows a title with gradient at the top of the analytics component
     */
    title: PropTypes.string,
    /**
     * (optional) Overrides event labels (descriptions) that are displayed i.e. in Filters section dropdowns
     */
    eventLabelsOverride: PropTypes.object,
    /**
     * List of ads fraud indicators for dropdown. Used to select preset column displays for different types of fraud.
     */
    fraudIndicators: PropTypes.object,
    defaultFraudIndicator: PropTypes.string,
    minEvents: PropTypes.number,
    maxEvents: PropTypes.number,
    debounceQuery: PropTypes.bool,
    partialLoadOnLongRange: PropTypes.bool,

    // Used to identify changes to selected columns/datasources and reset runFullReport flag
    columnKeys: PropTypes.array,

    // Used to signify that the underlying query for tabular data will be executed using the domain analytics paradigm
    useAnalyticsReport: PropTypes.bool,

    // Used to signify that the underlying query for time-series data will be executed using the domain analytics paradigm
    useAnalyticsTrends: PropTypes.bool,
  };

  static defaultProps = {
    maxDimensions: 2,
    minDimensions: 0,
    maxEvents: 2,
    minEvents: 1,
    data_sources: ['eo_click'],
    defaultFilter: {},
    default_dimensions: [],
    initialUnique: true,
    initialOrganic: false,
    disableUniqueToggle: false,
    disableOrganicToggle: false,
    hasExportButton: false,
    hasUniqueToggle: true,
    hasOrganicToggle: true,
    testid: 'analytics',
    debounceQuery: false,
    partialLoadOnLongRange: false,
    useAnalyticsReport: false,
    useAnalyticsTrends: false,
  };

  _getShareableStateForNamespace() {
    const { shareableNamespace } = this.props;
    return store.getState().shareable.getPageState(shareableNamespace || 'other');
  }

  _getShareableState() {
    const { context } = this.props;
    return this._getShareableStateForNamespace()[context] || {};
  }

  _setShareableState(data) {
    if (typeof data.runFullReport !== 'boolean') {
      data.runFullReport = false;
    }
    const { context, setPageState, shareableNamespace } = this.props;
    setPageState(shareableNamespace, {
      [context]: R.merge(this._getShareableState(), data),
    });
  }

  componentWillMount() {
    const {
      getAdPartners,
      data_sources,
      eventList,
      defaultFilter,
      requiredFilter,
      overrideInitialFilter,
      overrideInitialDimensions,
      default_dimensions,
      initialOrganic,
      initialUnique,
      defaultBlockedEventIndicator,
      dataSourceSpecificQueryOptions,
      context,
      toggleFraudDescription,
      disableOrganicToggle,
      hasOrganicToggle,
    } = this.props;

    let shareableState = this._getShareableState();
    if (shareableState.sourceQuery) {
      shareableState = {
        ...shareableState,
        sourceQuery: convertMultipleQueriesToNativeDruidFilters(shareableState.sourceQuery),
      };
    }

    getAdPartners();

    const filter = mergeFilters(defaultFilter || {}, requiredFilter || {});

    const events = getEventForTimeseries(data_sources, eventList);

    const sourceQuery = addStandardSourceQueryForEvents(dataSourceSpecificQueryOptions, events);

    const organic = deriveOrganic({
      shareableStateOrganic: shareableState.organic,
      disableOrganicToggle,
      initialOrganic,
      hasOrganicToggle,
    });

    shareableState = {
      ...shareableState,
      organic,
    };

    // [EG-3024] Set granularity and dimensions for shareable state stored before GroupBy Interval was supported
    const shareableDimensions = overrideInitialDimensions || (shareableState.query && shareableState.query.dimensions);
    const defaultGranularity = getDefaultGranularityFromContext(context);
    const updatedDimensions = updateDimensionsWithDate(
      shareableState.granularity || defaultGranularity,
      shareableDimensions || default_dimensions
    );
    if (updatedDimensions.includes('fraud_codes')) {
      toggleFraudDescription(true);
    }

    const initState = {
      /**
       * event represents the event selected in the SHOW: dropdown for timeseries chart
       */
      events: events,
      query: {
        data_sources: data_sources,
        filter,
        dimensions: updatedDimensions,
      },
      sourceQuery,
      unique: initialUnique,
      organic,
      granularity: defaultGranularity,
      blockedEventIndicator: defaultBlockedEventIndicator,
    };

    if (shareableState.sourceQuery && !Object.keys(shareableState.sourceQuery).length) {
      shareableState = {
        ...shareableState,
        sourceQuery,
      };
    }

    this._setShareableState(R.merge(initState, shareableState));
    const overrideState = {
      dimensions: updatedDimensions,
    };
    if (overrideInitialFilter) {
      Object.assign(overrideState, {
        filter: mergeFilters(overrideInitialFilter, requiredFilter || {}),
        filters: null,
      });
      this.updateQuery(overrideState);
      this.updateFraudType(null);
      this.updateBlockedEventIndicator('none');
    }
  }

  _getQuery = () => {
    const props = this.props;
    let shareableQuery = convertFiltersToNativeDruidFilters(this._getShareableState().query || {});

    // required filters should always be used
    const filter = mergeFilters(shareableQuery.filter || {}, props.requiredFilter || {});

    shareableQuery = Object.assign(shareableQuery, {
      filter,
      filters: undefined,
    });

    return Object.assign(
      {
        app_id: AppsStore.getAppId(),
        start_date: props.start_date,
        end_date: props.end_date,
        granularity: props.granularity || 'all',
        eo_cutoff_date: props.eo_cutoff_date,
        context: props.context,
      },
      shareableQuery
    );
  };

  /**
   * Get deduplicated non null/empty list of data sources from the
   * selected columns
   * Currently, this only works for tables.
   * @return {Array<String>}
   */
  _getDataSources = () => {
    const { context } = this.props;
    const shareableState = this._getShareableStateForNamespace();
    let selectedColumns = shareableState.selectedColumns;

    switch (context) {
      case 'skadnetwork-table':
        selectedColumns = shareableState[context].selectedColumns;
        if (!selectedColumns) {
          return [];
        }

        if (selectedColumns.find((column) => column.key === SK_ADNETWORK_DATASOURCE)) {
          return [SK_ADNETWORK_DATASOURCE];
        }

        return [];

      case 'skadnetwork-time-series':
        return removeEventDescriptionsFromEvents(shareableState[context].events || []);
      case 'fraud-table':
        selectedColumns = shareableState[context].selectedColumns;
        return [
          ...new Set(
            selectedColumns &&
              selectedColumns.flatMap((column) => {
                return (
                  column.dataSources &&
                  column.dataSources.flatMap((source) => {
                    return source.includes('_blocked') ? [source, source.split('_blocked')[0]] : source;
                  })
                );
              })
          ),
        ]
          .filter((column) => !!column)
          .sort();
      case ANALYTICS_CONTEXT.SUMMARY_TABLE:
      case 'source-table':
      case ANALYTICS_CONTEXT.EMAILS_TABLE:
      case ANALYTICS_CONTEXT.JOURNEYS_TABLE:
      case ANALYTICS_CONTEXT.ADS_TABLE:
      case ANALYTICS_CONTEXT.SEO_TABLE:
      case ANALYTICS_CONTEXT.TRUEVIEW_TABLE:
      case ANALYTICS_CONTEXT.OTT_TABLE:
        return [
          ...new Set(
            selectedColumns &&
              selectedColumns.flatMap((column) => {
                return column.dataSources;
              })
          ),
        ]
          .filter((column) => !!column)
          .sort();
      default:
        return shareableState[context].query.data_sources.sort();
    }
  };

  _getColumns = () => {
    const { context } = this.props;
    const shareableState = this._getShareableStateForNamespace();

    let columns = [];
    switch (context) {
      case 'skadnetwork-table':
      case 'fraud-table':
        columns = shareableState[context].selectedColumns || [];
        break;
      case ANALYTICS_CONTEXT.SUMMARY_TABLE:
      case 'source-table':
      case ANALYTICS_CONTEXT.EMAILS_TABLE:
      case ANALYTICS_CONTEXT.JOURNEYS_TABLE:
      case ANALYTICS_CONTEXT.ADS_TABLE:
      case ANALYTICS_CONTEXT.SEO_TABLE:
      case ANALYTICS_CONTEXT.TRUEVIEW_TABLE:
      case ANALYTICS_CONTEXT.OTT_TABLE:
        columns = shareableState.selectedColumns || [];
        break;
    }
    return columns
      .map((c) => getColumnDataFieldKey(c.type, c.key))
      .filter((reportColumnKey) => reportColumnKey)
      .sort();
  };

  _getTopics = () => {
    const shareableState = this._getShareableStateForNamespace();
    const topics = shareableState?.[this.props.context]?.events || [];
    const serverSideTopicNames = topics.map(getServerSideTopicNamesForTrends);
    return serverSideTopicNames;
  };

  _getOrderBy = () => {
    const shareableState = this._getShareableStateForNamespace();
    if (!shareableState.localSortDisabled) {
      return;
    }
    return this.props.orderBy;
  };

  _redactQueryBasedOnAccess = (query) => {
    const props = this.props;

    const filterDimensionsAndValues = getListOfDimensionsAndValues(query.filter);

    const partnerReportFilters =
      filterDimensionsAndValues && filterDimensionsAndValues.last_attributed_touch_data_tilde_advertising_partner_name;
    if (
      partnerReportFilters &&
      props.adPartner.hasPartnersLoaded &&
      props.accessControl.data.ad_networks.access_filter instanceof Array
    ) {
      const partnersUserCanAccess = {};
      const availablePartners = props.adPartner.partners;
      props.accessControl.data.ad_networks.access_filter.forEach((machineName) => {
        const adPartner = availablePartners.find((partner) => partner.machine_name === machineName);

        if (adPartner) {
          // check company name(for regular ad partners) or publisher_name(for custom ad partners)
          partnersUserCanAccess[adPartner.company_name || adPartner.publisher_name] = adPartner;
        }
      });

      const redactedPartnerQuery = partnerReportFilters.filter((partnerName) => partnersUserCanAccess[partnerName]);
      if (partnerReportFilters.length !== redactedPartnerQuery.length) {
        const row = convertNativeFiltersToDisplayFormat(query.filter).filter(
          (v) => v.dimension === 'last_attributed_touch_data_tilde_advertising_partner_name'
        )[0];
        const filter = updateFilter(query.filter, row, null, null, redactedPartnerQuery);
        return {
          ...query,
          filter,
        };
      }
    }
    return query;
  };

  componentWillReceiveProps(nextProps) {
    const { data_sources, default_dimensions, eventList, context, start_date, end_date, columnKeys } = nextProps;
    const shareableState = this._getShareableState();

    if (this.props.start_date !== start_date || this.props.end_date !== end_date) {
      this._setShareableState({ runFullReport: false });
    }

    if (columnKeys && this.props.columnKeys && !R.equals(columnKeys, this.props.columnKeys)) {
      this._setShareableState({ runFullReport: false });
    }

    if (!R.equals(default_dimensions, this.props.default_dimensions)) {
      this._setShareableState({
        query: R.assoc('dimensions', default_dimensions, shareableState.query),
      });
    }

    // reset this.state.query from props if data_sources has changed
    if (!R.equals(data_sources, this.props.data_sources)) {
      this.changeEvent(getEventForTimeseries(data_sources, eventList));
    }

    // [EG-3024] Set granularity and dimensions for bookmarks created before GroupBy Interval was supported
    const shareableDimensions = shareableState.query && shareableState.query.dimensions;
    const defaultGranularity = getDefaultGranularityFromContext(context);
    const updatedDimensions = updateDimensionsWithDate(
      shareableState.granularity || defaultGranularity,
      shareableDimensions || this.props.default_dimensions
    );

    if (!shareableState.granularity) {
      this._setShareableState({ granularity: defaultGranularity });
    }

    if (!R.equals(updatedDimensions, shareableDimensions)) {
      this.updateQuery({ dimensions: updatedDimensions });
    }

    const derivedOrganic = deriveOrganic({
      shareableStateOrganic: shareableState.organic,
      disableOrganicToggle: nextProps.disableOrganicToggle,
      initialOrganic: nextProps.initialOrganic,
      hasOrganicToggle: nextProps.hasOrganicToggle,
    });
    if (shareableState.organic !== derivedOrganic) {
      this._setShareableState({ organic: derivedOrganic });
    }
  }

  changeEvent = (events) => {
    const { dataSourceSpecificQueryOptions } = this.props;
    const sourceQuery = addStandardSourceQueryForEvents(dataSourceSpecificQueryOptions, events);

    this._setShareableState({
      events,
      sourceQuery,
    });
  };

  updateUnique = (event) => {
    this._setShareableState({ unique: event.target.checked });
  };

  updateOrganic = (event, granularity) => {
    this._setShareableState({ organic: event.target.checked });
  };

  updateSkanSplit = (event) => {
    const { context, setPageState, shareableNamespace } = this.props;

    setPageState(shareableNamespace, {
      [context]: this._getShareableState(),
      splitSkanData: event.target.checked,
    });
  };

  updateBlockedEventIndicator = (blockedEventIndicator) => {
    const shareableState = this._getShareableState();
    // only set blockedEventIndicator if shareable state already has a value set for blockedEventIndicator
    if (!!shareableState.blockedEventIndicator) {
      this._setShareableState({ blockedEventIndicator });
    }
  };

  updateBlockedEventType = (config) => {
    if (!config) {
      this._setShareableState({
        blockedEventIndicator: DEFAULT_BLOCKED_EVENT_INDICATOR,
      });
      return;
    }

    const shareableState = this._getShareableState();
    this._setShareableState({
      blockedEventIndicator: config.value || DEFAULT_BLOCKED_EVENT_INDICATOR,
      fraudIndicator: 'custom',
      selectedColumns: config.selectedColumns || shareableState.selectedColumns,
      activeHeader: config.activeHeader || shareableState.activeHeader,
      isReversedHeader: false,
      granularity: 'all',
    });
  };

  updateFraudType = (config) => {
    if (!config) {
      this._setShareableState({ fraudIndicator: 'custom' });
      return;
    }

    const shareableState = this._getShareableState();
    this._setShareableState({
      blockedEventIndicator: 'none',
      fraudIndicator: config.value || 'custom',
      selectedColumns: config.selectedColumns || shareableState.selectedColumns,
      activeHeader: config.activeHeader || shareableState.activeHeader,
      isReversedHeader: false,
      granularity: 'all',
    });
  };

  updateFraudTypeOnCompareByChange = () => {
    this._setShareableState({
      fraudIndicator: 'custom',
    });
  };

  updateQuery = (nextQuery) => {
    const shareableState = this._getShareableState();
    this._setShareableState({
      query: R.merge(shareableState.query, nextQuery),
    });
  };

  updateGranularity = (config) => {
    const shareableState = this._getShareableState();

    // do not update shareableState or query if any of the following are falsey
    if (!config || !shareableState || !shareableState.query || !shareableState.query.dimensions) {
      return;
    }

    const defaultGranularity = getDefaultGranularityFromContext(this.props.context);
    const updatedGranularity = config.value || defaultGranularity;
    const updatedDimensions = updateDimensionsWithDate(updatedGranularity, shareableState.query.dimensions);

    this._setShareableState({ granularity: updatedGranularity });

    this.updateQuery({
      granularity: updatedGranularity,
      dimensions: updatedDimensions,
    });
  };

  fetchFilters = (dimension) => {
    const shareableState = this._getShareableState();
    const { start_date, end_date } = this.props;
    const { query } = shareableState;
    return this.props.getDruidFiltersByDimension({ start_date, end_date }, [dimension], query.data_sources);
  };

  /**
   * Updates showFraudDescription state in parent. Additionally, updates
   * the dimensions with 'fraud_codes' if showFraudDescription is toggled to
   * be 'true'
   */
  _toggleFraudDescription = (e: Object) => {
    const { toggleFraudDescription } = this.props;
    let dimensions = this._getShareableState().query.dimensions;
    if (e.target.checked) {
      if (!dimensions.includes('fraud_codes')) {
        dimensions = [...dimensions, 'fraud_codes'];
        this.updateQuery({ dimensions });
      }
      return toggleFraudDescription(true);
    }

    return toggleFraudDescription(false);
  };

  _generateAdditionalQueries = () => {
    const { context } = this.props;
    const shareableState = this._getShareableState();
    const query = this._getQuery();
    switch (context) {
      case 'skadnetwork-table':
        return generateAdditionalQueriesFromEvents({
          query,
          events: getNonDimensionColumnKeysFromSelectedColumns(shareableState.selectedColumns),
        });
      case 'skadnetwork-time-series':
        return generateAdditionalQueriesFromEvents({
          query,
          events: shareableState.events || [],
        });
      default:
        return undefined;
    }
  };

  _removeDateRangeFromDruidQueryDimensions = (dimensions: string[]) => {
    return dimensions?.filter((dimension) => dimension !== 'date_range');
  };

  render() {
    const shareableState = this._getShareableState();
    const namespaceState = this._getShareableStateForNamespace();
    const query = Object.assign({}, this._getQuery(), {
      data_sources: this._getDataSources(),
    });

    const {
      druid,
      maxDimensions,
      minDimensions,
      maxEvents,
      minEvents,
      requiredFilter,
      implicitRequiredFilter,
      title,
      eventList,
      disableUniqueToggle,
      hasExportButton,
      testid,
      hasUniqueToggle,
      hasOrganicToggle,
      hasSplitSkanDataToggle,
      blockedEventIndicators,
      defaultBlockedEventIndicator,
      fraudIndicators,
      defaultFraudIndicator,
      context,
      hasFraudDescriptionToggle,
      dataSourceSpecificQueryOptions,
      useDataSourceSpecificQueryOptionsAsSourceQuery,
      showFraudDescription,
      excludeCustomEvents,
      customLabelMap,
      disableOrganicToggle,
      debounceQuery,
      partialLoadOnLongRange,
      useAnalyticsReport,
      useAnalyticsTrends,
      eventLabelsOverride,
      shareableNamespace,
    } = this.props;

    const isPartialLoad = partialLoadOnLongRange && !shareableState.runFullReport && shouldLoadPartialData(query);

    if (isPartialLoad) {
      query.end_date = getSampleEndDate(query);
    }

    const dimensionsToCompareBy = this.props.filterTypesList;
    const dimensionsToFilterBy = this.props.filterTypesListFilterRow || dimensionsToCompareBy;
    const completeEventList = eventList && eventList.concat(druid.custom_event_list);

    const redactedQuery = this._redactQueryBasedOnAccess(query);

    const sourceQuery = useDataSourceSpecificQueryOptionsAsSourceQuery
      ? addStandardSourceQueryForEvents(dataSourceSpecificQueryOptions, shareableState.events)
      : shareableState.sourceQuery;

    const { filter: userFilter } = query;
    const mergedFilter = mergeFilters(userFilter, implicitRequiredFilter, true);
    const druidQuery = Object.assign({}, query, { filter: mergedFilter });
    const additionalQueries = this._generateAdditionalQueries();

    let reportQuery, trendsQuery;
    if (isDomainAnalyticsAvailable(druidQuery.context)) {
      if (useAnalyticsReport) {
        reportQuery = {
          start_date: druidQuery.start_date,
          end_date: druidQuery.end_date,
          granularity: druidQuery.granularity,
          context: druidQuery.context,
          dimensions: this._removeDateRangeFromDruidQueryDimensions(druidQuery.dimensions),
          columns: this._getColumns(),
          orderBy: this._getOrderBy(),
        };
      }
      if (useAnalyticsTrends) {
        trendsQuery = {
          start_date: druidQuery.start_date,
          end_date: druidQuery.end_date,
          granularity: druidQuery.granularity,
          context: druidQuery.context,
          compareBy: druidQuery.dimensions?.find((dimension) => dimension !== 'date_range'),
          topics: this._getTopics(),
        };
      }
    }

    return (
      <div className="analytics" data-testid={this.props.testid}>
        {title ? <div className="analytics__title">{title}</div> : null}
        <div className={classNames('analytics__container', { 'analytics__container-with-title': !!title })}>
          <PureQueryBuilder
            eventSelect={
              <MultiEventSelect
                events={shareableState.events}
                eventList={excludeCustomEvents ? eventList : completeEventList}
                updateEvent={this.changeEvent}
                queryParam={'data_sources'}
                maxEvents={maxEvents}
                minEvents={minEvents}
                eventLabelsOverride={eventLabelsOverride}
              />
            }
            fraudSelect={
              <FraudSelect
                blockedEventIndicator={shareableState.blockedEventIndicator}
                blockedEventIndicators={blockedEventIndicators}
                defaultBlockedEventIndicator={defaultBlockedEventIndicator}
                updateBlockedEventType={this.updateBlockedEventType}
                fraudIndicator={shareableState.fraudIndicator}
                fraudIndicators={fraudIndicators}
                defaultFraudIndicator={defaultFraudIndicator}
                updateFraudType={this.updateFraudType}
                updateOrganic={this.updateOrganic}
              />
            }
            dimensions={query.dimensions}
            updateFraudTypeOnCompareByChange={this.updateFraudTypeOnCompareByChange}
            dimensionsToCompareBy={dimensionsToCompareBy}
            maxDimensions={maxDimensions}
            minDimensions={minDimensions}
            allFilters={druid.filters}
            filter={redactedQuery.filter}
            fetchFilters={this.fetchFilters}
            dimensionsToFilterBy={dimensionsToFilterBy}
            requiredFilter={requiredFilter}
            unique={shareableState.unique}
            updateUnique={this.updateUnique}
            disableUniqueToggle={disableUniqueToggle}
            organic={shareableState.organic}
            updateOrganic={this.updateOrganic}
            disableOrganicToggle={disableOrganicToggle}
            hasFraudDescriptionToggle={hasFraudDescriptionToggle}
            showFraudDescription={showFraudDescription}
            toggleFraudDescription={this._toggleFraudDescription}
            hasExportButton={hasExportButton}
            testid={testid}
            hasUniqueToggle={hasUniqueToggle}
            hasOrganicToggle={hasOrganicToggle}
            hasSplitSkanDataToggle={hasSplitSkanDataToggle}
            splitSkanData={namespaceState.splitSkanData}
            updateSkanSplit={this.updateSkanSplit}
            updateQuery={this.updateQuery}
            updateGranularity={this.updateGranularity}
            granularity={shareableState.granularity}
            updateBlockedEventIndicator={this.updateBlockedEventIndicator}
            context={context}
            query={druidQuery}
            customLabelMap={customLabelMap}
            namespace={shareableNamespace}
          />
          <DruidQuery
            type={this.props.type || 'groupby'}
            query={druidQuery}
            sourceQuery={sourceQuery}
            overrides={this.props.overrides}
            unique={shareableState.unique}
            organic={shareableState.organic}
            additionalQueries={additionalQueries}
            isPartialLoad={isPartialLoad}
            debounce={debounceQuery}
            reportQuery={!trendsQuery ? reportQuery : undefined}
            trendsQuery={!reportQuery ? trendsQuery : undefined}
          >
            {React.Children.map(this.props.children, (child) => {
              if (child) {
                return (
                  React.cloneElement(child, {
                    events: shareableState.events,
                    data_sources: this.props.data_sources,
                  }) || null
                );
              }
            })}
          </DruidQuery>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  druid: getDruidState(state),
  accessControl: selectAccessControl(state),
  adPartner: selectAdPartner(state),
  disableOrganicToggle: selectDisableOrganicToggle(state, ownProps),
  orderBy: selectNamespaceOrderBy(state, ownProps),
});

const mapDispatchProps = (dispatch) => ({
  setPageState: (namespace, state) => dispatch(setPageState(namespace, state)),
  getAdPartners: () => dispatch(getAdPartners({})),
  getDruidFiltersByDimension: (dateRange, dimensions, dataSources) =>
    dispatch(getDruidFiltersByDimension(dateRange, dimensions, dataSources)),
});

export default connect(mapStateToProps, mapDispatchProps)(DruidQueryBuilder);
